import React, {useState} from 'react'
import '../css/Navbar.css'
// import logo from '../assets/mock-logo.webp'
import {FaBars, FaTimes} from 'react-icons/fa'


const Navbar = () => {

const [burgerClick, setBurgerClick] = useState(false)
const [navBack, setNavBack] = useState(false)

const handleBurgerClick = () => setBurgerClick(!burgerClick)

const changeNavBack = () => {
    if (window.scrollY >= 90)
    {
        setNavBack(true)
    }
    else
    {
        setNavBack(false)
    }
}


window.addEventListener('scroll', changeNavBack);



    return (
        <div className={navBack ? 'header navbar-bg' : 'header'}>
            <div className='navbar'>
                <a href='/' className='logo'>
                    {/* <img src={logo} alt='logo' /> */}
                </a>
                <div className='hamburger' onClick={handleBurgerClick}>
                    {burgerClick ? (<FaTimes size={30} style={{color: '#ffffff'}} />) : (<FaBars size={30} style={{color: '#ffffff'}} />)}
                </div>
                <ul className={burgerClick ? "nav-menu active" : "nav-menu"}>
                    <li className='nav-item'>
                        <a href='/'>Home</a>
                    </li>
                    <li className='nav-item'>
                        <a href='#about'>About</a>
                    </li>
                    <li className='nav-item'>
                        <a href='#pricing'>Get a Quote</a>
                    </li>
                    {/* <li className='nav-item'>
                        <a href='/'>Demo</a>
                    </li> */}
                </ul>
            </div>
        </div>
    )
}

export default Navbar